import {
  Code,
  FileText,
  Gauge,
  LayoutDashboard,
  Link as LinkIcon,
  User,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { User as AuthUser } from '../../../store/authStore';

export type MerchantNavItem = {
  path: string;
  label: string;
  description: string;
  icon: LucideIcon;
  moduleCode?: string;
  alwaysVisible?: boolean;
  group: 'Analytics' | 'Support' | 'Developers' | 'Account';
};

export const MERCHANT_NAV_ITEMS: MerchantNavItem[] = [
  {
    path: '/dashboard/transaction-dashboard',
    label: 'Dashboards',
    description: 'Transaction analytics',
    icon: LayoutDashboard,
    moduleCode: 'TRAN-MON-09',
    group: 'Analytics',
  },
  {
    path: '/dashboard/transaction-monitoring',
    label: 'Monitoring',
    description: 'Orders and settlements',
    icon: Gauge,
    moduleCode: 'TRAN-MON-09',
    group: 'Support',
  },
  {
    path: '/dashboard/developers',
    label: 'Developers',
    description: 'API keys and webhooks',
    icon: Code,
    moduleCode: 'MERCH-DEVELOPERS',
    group: 'Developers',
  },
  {
    path: '/dashboard/documentation',
    label: 'Documentation',
    description: 'Integration guides',
    icon: FileText,
    moduleCode: 'MERCH-DOCS',
    group: 'Developers',
  },
  {
    path: '/dashboard/storefront-urls',
    label: 'URLs',
    description: 'Storefront domains',
    icon: LinkIcon,
    moduleCode: 'MERCH-STOREFRONT-URLS',
    group: 'Developers',
  },
  {
    path: '/dashboard/profile',
    label: 'Profile',
    description: 'Account settings',
    icon: User,
    moduleCode: 'PROFILE',
    group: 'Account',
  },
];

export function getVisibleMerchantNav(user: AuthUser | null): MerchantNavItem[] {
  const viewableModuleCodes = new Set(
    (user?.moduleAccesses ?? []).filter((access) => access.canView).map((access) => access.moduleCode),
  );

  return MERCHANT_NAV_ITEMS.filter(
    (item) => item.alwaysVisible || (item.moduleCode && viewableModuleCodes.has(item.moduleCode)),
  );
}

export function getUserInitials(name?: string): string {
  if (!name?.trim()) return 'U';
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`.toUpperCase();
  }
  return name.charAt(0).toUpperCase();
}
